import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useContext } from "react";

import { getRanaApiV1 } from "@nens/rana/api-v1";

import { ProjectContext } from "@/stores/project-provider";
import { ProjectFile } from "@/types/api-model-simple-names";

import { queryDirectly } from "./hooks/query-directly";

// Single

const ONE_HOUR = 3600000;

const getFileDownloadQuery = (projectId: string, file: ProjectFile | undefined) => {
  return getRanaApiV1().getQueryOptions({
    queryKey: ["project", projectId, "file", file?.id, "download_url", file?.etag],
    queryFn: async () => {
      if (!file) throw Error("Never happens");

      return (await getRanaApiV1().FilesApi.projectDownload({ projectId, path: file.id })).url;
    },
    // File download urls are invalidated after 1 hour.
    refetchInterval: ONE_HOUR,
    enabled: !!file,
  });
};

export const useFileDownloadQueryDirectly = () => {
  const { id: projectId } = useContext(ProjectContext);
  const queryClient = useQueryClient();

  return async (file: ProjectFile) =>
    queryDirectly(queryClient, getFileDownloadQuery(projectId, file));
};

export const useFileDownloadQuery = (file: ProjectFile | undefined) => {
  const { id: projectId } = useContext(ProjectContext);

  return useQuery(getFileDownloadQuery(projectId, file));
};
